import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';
import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';
import { isLoading as isRaceLoading, load as loadRace } from '../reducers/race';
import { loadByEventIdStoryType, isLoadingByEventIdStoryType, lookupRef } from 'modules/Common/reducers/article';
import { isLoading, load as loadMeetings, get as getMeetings } from '../reducers/meetings';
import { isMeetingLoading, loadMeetingByRaceId } from '../reducers/meeting';
import { getTodaysDate, isBefore } from 'utils/LocalDateTimeHelper';

import _ from "lodash";

import HorseRacingRacePage from '../components/HorseRacingRacePage';

const TIPS_STORY_TYPE = 'TIPS_FOR_HORSE_RACING';

const LONG_INTERVAL_MS   = 5 * 60 * 1000;
const MEDIUM_INTERVAL_MS =     30 * 1000;
const SHORT_INTERVAL_MS  =     15 * 1000;
const ACTIVE_INTERVAL_MS =      5 * 1000;
const NO_INTERVAL        = false;

const ACTIVE_STATUSES = ["GOINGDOWN", "ATTHEPOST", "GOINGBEHIND", "GOINGINSTALLS", "UNDERORDERS", "OFF", "FINISHED", "PHOTOGRAPH", "RESULT"];

function raceInterval({
  state: {
    horseRacing: {
      race: {
        race: {
          race_summary: {
            time,
            race_stage,
            date
          } = {}
        } = {}
      } = {}
    } = {}
  }
}) {
  const timeStamp = `${date}T${time}Z`;
  let interval;

  if (ACTIVE_STATUSES.includes(race_stage)) {
    interval = ACTIVE_INTERVAL_MS;
  }
  else if (isBefore(timeStamp, -3, "day")) {
    interval = NO_INTERVAL;
  }
  else if (isBefore(timeStamp, -1, "day")) {
    interval = LONG_INTERVAL_MS;
  }
  else if (isBefore(timeStamp, -15, "minutes")) {
    interval = MEDIUM_INTERVAL_MS;
  }
  else if (isBefore(timeStamp, 15, "minutes")) {
    interval = SHORT_INTERVAL_MS;
  }
  else if (isBefore(timeStamp, 1, "day")) {
    interval = LONG_INTERVAL_MS;
  }
  else {
    interval = NO_INTERVAL;
  }

  return interval;
}

@standardAsyncConnect([
  { // this race
    dispatch: ({params: {raceId}}) => loadRace(raceId),
    preventResolve: ({state, params: {raceId}}) => isRaceLoading(state, raceId),
    state: state => ({race: state.horseRacing.race || {}}),
    refreshInterval: raceInterval
  },
  { // meetings for this date
    dispatch: ({params: {date = getTodaysDate("YYYY-MM-DD")}}) => loadMeetings(date),
    preventResolve: ({state, params: {date = getTodaysDate("YYYY-MM-DD")}}) => isLoading(state, date),
    state: state => ({meetingsByDate: getMeetings(state)})
  },
  { // meeting for this race
    dispatch: ({params: {raceId}}) => loadMeetingByRaceId(raceId),
    preventResolve: ({state, params: {raceId}}) => isMeetingLoading(state, raceId),
    state: state => ({meeting: state.horseRacing.meeting || {}})
  },
  { // tips article for this race
    dispatch: ({params: {raceId}}) => loadByEventIdStoryType(null, raceId, TIPS_STORY_TYPE),
    preventResolve: ({state, params: {raceId}}) => isLoadingByEventIdStoryType(state, raceId, TIPS_STORY_TYPE),
    state: (state, props) => ({tipsArticle: getArticle(state.common.article, lookupRef(props.params.raceId, TIPS_STORY_TYPE)) || {}})
  },
  userServiceLayoutConnect()
])
@catchLifeCycleErrors
export default class HorseRacingRacePageContainer extends Component {
  static propTypes = {
    route: PropTypes.object,
    // supplied by react-router via @connect
    params: PropTypes.shape({
      date: PropTypes.string
    }),
    routes: PropTypes.array.isRequired,
    meetingsByDate: PropTypes.object,
    meeting: PropTypes.object,
    tipsArticle: PropTypes.object,
    race: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.node
  };

  hasMatchingRaceIds() {
    const stateRaceId = _.get(this.props, "race.race.race_summary.race_summary_reference.id");
    const currentRaceId = _.get(this.props, "params.raceId");
    
    return `${stateRaceId}` === currentRaceId;
  }

  render() {
    if(this.props.meeting && !_.isEmpty(this.props.meeting.meeting)){
      this.props.meeting.meeting[0].races = _.sortBy(this.props.meeting.meeting[0].races, ['date', 'time']);
    }

    // If we have an error and we dont have race data or the race ID we are 
    // viewing doesnt match whats in state then show the error
    if (this.props.race.error && (!this.props.race.race || !this.hasMatchingRaceIds())) {
      const errorPixelSrc = `/1x1.gif?type=horseracing-racecard&id=0&cb=${Date.now()}`;

      return (
        <div className="hr-racing-racecards">
          <p className="hr-racing-racecards-error-message">There has been a problem displaying this race.</p>
          <img src={errorPixelSrc} width="1" height="1" />
        </div>
      );
    }

    const racePageProps = {
      race: this.props.race.race,
      meetings: this.props.meetingsByDate[this.props.params.date],
      meeting: this.props.meeting,
      children: this.props.children,
      tipsArticle: this.props.tipsArticle,
      routes: this.props.routes,
      route: this.props.route,
      params: this.props.params
    };

    return (
      <HorseRacingRacePage {...racePageProps}/>
    );

  }
}

function getArticle(articles, ref) {
  // ArticleIdRefs maps reference values to article ids which are the main index of articles object
  const id = _.get(articles, `articleIdRefs[${ref}].articleIds[0]`);
  if (id) {
    return articles[id].article;
  } else {
    return {};
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/HorseRacingRacePageContainer.js